import React, { useState, useEffect, useCallback } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';

import './App.css';
import NotificationReceived from './NotificationReceived';
import RegBy from './RegBy';
import SMS_Receive from './SMS_Receive';
import G9_Ports_Voip from './G9_Ports_Voip';
import GoipStats from './GoipStats';
import Advanced from './Advanced';
import ImeiConfig from './ImeiConfig';
import Bridge from './Bridge';
import LoginForm from './LoginForm';
import Reloadly from './Reloadly';
import FinancialTrackerPage from './tracker/pages/FinancialTrackerPage';
import MyAppBar from './MyAppBar';
import Testing from './Testing';
import Gatez_offline from './Gatez_offline';
import Loader from './Loader';
import GoipManagement_offline from './GoipManagement_offline';
import Scheduler from './Scheduler';
import Simregbot from './Simregbot';
import Auto_Load from './Auto_Load';
import SMS_Logs from './SMS_Logs';
import Call_Logs from './Call_Logs';
import Snapshot from './Snapshot';

import Earntracker from './Earntracker';



// Add these with your other tracker imports at the top of App.js
import TrackerDashboard from './tracker/components/TrackerDashboard';
import TransactionHistoryPage from './tracker/pages/TransactionHistoryPage';



import G9_Auto from './G9_Auto';




import G9PortsBingo from './G9PortsBingo';
import G9PortsBingoIndividual from './G9PortsBingoIndividual';
import OtpServicesManager from './OtpServicesManager';
import SmsVoipManager from './SmsVoipManager';
import VoipReportToolPage from './VoipReportToolPage';
import CatchedNumbers from './CatchedNumbers';
import {
  Card,
  Typography,
  Grid,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
  TextField,
} from '@mui/material';

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);
  const [isPhoneUser, setIsPhoneUser] = useState(false);

  const checkLoginStatus = useCallback(() => {
    const savedLoginState = localStorage.getItem('isLoggedIn');
    const loginTimestamp = localStorage.getItem('loginTimestamp');
    if (savedLoginState !== null && loginTimestamp !== null) {
      const now = new Date().getTime();
      const timeElapsed = now - parseInt(loginTimestamp, 10);
      const EXPIRATION_TIME = 24 * 60 * 60 * 1000; // 1 day

      if (timeElapsed < EXPIRATION_TIME) {
        setIsLoggedIn(JSON.parse(savedLoginState));
        setIsPhoneUser(localStorage.getItem('isPhoneUser') === 'true');
      } else {
        localStorage.removeItem('isLoggedIn');
        localStorage.removeItem('loginTimestamp');
        localStorage.removeItem('isPhoneUser');
      }
    }
    setIsLoaded(true);
  }, []);

  useEffect(() => {
    checkLoginStatus();
  }, [checkLoginStatus]);

  useEffect(() => {
    if (isLoaded) {
      localStorage.setItem('isLoggedIn', JSON.stringify(isLoggedIn));
      if (isLoggedIn) {
        localStorage.setItem('loginTimestamp', new Date().getTime().toString());
      }
    }
  }, [isLoggedIn, isLoaded]);

  const handleLogin = async (username, password, otp) => {
    try {
      const response = await fetch('https://frek.cc/proxy/38.54.86.24:19564/validate-otp', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ username, password, otp }),
      });

      const data = await response.json();

      if (response.ok) {
        setIsLoggedIn(true);
        localStorage.setItem('isLoggedIn', 'true');
        localStorage.setItem('loginTimestamp', new Date().getTime().toString());
      } else {
        throw new Error(data.error || 'Invalid OTP or login failed');
      }
    } catch (error) {
      console.error('Login error:', error);
      throw error; // Pass the error to the LoginForm component for handling
    }
  };

  const handleSetupTOTP = async (username, password) => {
    try {
      const response = await fetch('https://frek.cc/proxy/38.54.86.24:19564/generate-otp-secret', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ username, password }),
      });

      const data = await response.json();
      if (response.ok) {
        return data;
      } else {
        throw new Error(data.error || 'Failed to set up OTP');
      }
    } catch (error) {
      console.error('Setup TOTP error:', error);
      throw error; // Pass the error to the LoginForm component for handling
    }
  };

  if (!isLoaded) {
    return null; // Display nothing or a loader until the component is loaded
  }

  if (!isLoggedIn) {
    return (
      <LoginForm onLogin={handleLogin} onSetupTOTP={handleSetupTOTP} />
    );
  }

  return (
    <div className="App">
      <MyAppBar />
      <Routes>
        {isPhoneUser ? (
          <>

            <Route path="*" element={<Navigate to="/phone" />} />
          </>
        ) : (
          <>
            <Route path="/" element={<Gatez_offline />} />
            <Route path="/Reloadly" element={<Reloadly />} />

            <Route path="/ImeiConfig" element={<ImeiConfig />} />
            <Route path="/Testing" element={<Testing />} />
            <Route path="/G9_Ports_Voip" element={<G9_Ports_Voip />} />
            <Route path="/Advanced" element={< Advanced />} />
            <Route path="/RegBy" element={<RegBy />} />
            <Route path="/G9_Auto" element={<G9_Auto />} />
            <Route path="/Earntracker" element={<Earntracker />} />
            <Route path="/Loader" element={<Loader />} />
            <Route path="/GoipManagement_offline" element={<GoipManagement_offline />} />
            <Route path="/Scheduler" element={<Scheduler />} />
            <Route path="/Auto_Load" element={<Auto_Load />} />
            {/* REPLACE the old Fintracker route with this block */}
            <Route path="/Fintracker" element={<FinancialTrackerPage />}>
              {/* The 'index' route is the default page shown at /Fintracker */}
              <Route index element={<TrackerDashboard />} />

              {/* This is the page shown at /Fintracker/history */}
              <Route path="history" element={<TransactionHistoryPage />} />
            </Route>
            <Route path="/Bridge" element={<Bridge />} />
            <Route path="/NotificationReceived" element={<NotificationReceived />} />
            <Route path="/Simregbot" element={<Simregbot />} />
            <Route path="/SMS_Logs" element={<SMS_Logs />} />
            <Route path="/Call_Logs" element={<Call_Logs />} />
            <Route path="/Snapshot" element={<Snapshot />} />
            <Route path="/GoipStats" element={<GoipStats />} />
            <Route path="/G9PortsBingo" element={<G9PortsBingo />} />
            <Route path="/G9PortsBingoIndividual" element={<G9PortsBingoIndividual />} />
            <Route path="/OtpServices" element={<OtpServicesManager />} />
            <Route path="/SmsVoipManager" element={<SmsVoipManager />} />
            <Route path="/VoipReportTool" element={<VoipReportToolPage />} />
            <Route path="/CatchedNumbers" element={<CatchedNumbers />} />
<Route path="/SMS_Receive" element={<SMS_Receive />} />


            <Route path="*" element={<Navigate to="/" />} />
          </>
        )}
      </Routes>
    </div>
  );
}

export default App;
